<template lang="pug">
  v-app
    loader-overlay
    modals-controller
    router-view
</template>

<script>
import LoaderOverlay from '@/components/Layout/LoaderOverlay.vue';
import ModalsController from '@/components/Layout/ModalsController/index.vue';

export default {
  components: {
    ModalsController,
    LoaderOverlay,
  },
};
</script>
